var _rect, _rect2, _circle, _circle2, _polygon, _polygon2, _polygon3, _polygon4, _polygon5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSingaporeFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 30,
    viewBox: "0 0 60 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 15,
    fill: "#ED2939"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 15,
    width: 60,
    height: 15,
    fill: "#FFFFFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 7.5,
    r: 6,
    fill: "#FFFFFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.2,
    cy: 7.5,
    r: 5,
    fill: "#ED2939"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "21,2.5 21.5,4 23.1,4 21.8,5 22.3,6.5 21,5.5 19.7,6.5 20.2,5 18.9,4 20.5,4",
    fill: "#FFFFFF"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "24.5,5.5 25,7 26.6,7 25.3,8 25.8,9.5 24.5,8.5 23.2,9.5 23.7,8 22.4,7 24,7",
    fill: "#FFFFFF"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "23,9.5 23.5,11 25.1,11 23.8,12 24.3,13.5 23,12.5 21.7,13.5 22.2,12 20.9,11 22.5,11",
    fill: "#FFFFFF"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "19,9.5 19.5,11 21.1,11 19.8,12 20.3,13.5 19,12.5 17.7,13.5 18.2,12 16.9,11 18.5,11",
    fill: "#FFFFFF"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "17.5,5.5 18,7 19.6,7 18.3,8 18.8,9.5 17.5,8.5 16.2,9.5 16.7,8 15.4,7 17,7",
    fill: "#FFFFFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingaporeFlag);
export default __webpack_public_path__ + "static/media/SingaporeFlag.50e2a3896738b641cc94d54d84ef1ef3.svg";
export { ForwardRef as ReactComponent };